import { useMemo } from 'react'
import { useWindowDimensions, ViewStyle, Platform } from 'react-native'

interface IVideoRotationProps {
  isFullScreenMode: boolean
  isVertical: boolean
}

export function useVideoRotation({
  isFullScreenMode,
  isVertical,
}: IVideoRotationProps): ViewStyle {
  const { width: windowWidth, height: windowHeight } = useWindowDimensions()
  const isIOS = Platform.OS === 'ios'

  return useMemo<ViewStyle>(() => {
    if (!isFullScreenMode && !isVertical) {
      return {
        width: '100%',
        height: '100%',
        transform: [],
      }
    }

    // Quando em fullscreen e landscape, giramos o vídeo e ajustamos as dimensões
    if (isIOS && !isVertical) {
      return {
        width: windowHeight,
        height: windowWidth,
        position: 'absolute',
        left: (windowWidth - windowHeight) / 2,
        top: (windowHeight - windowWidth) / 2,
        transform: [{ rotate: '90deg' }],
        backgroundColor: '$neutral-0',
      }
    }

    // No Android, precisamos ajustar o container e o vídeo separadamente
    return {
      width: '100%',
      height: '100%',
      position: 'absolute',
      left: 0,
      top: 0,
      backgroundColor: '$neutral-0',
    }
  }, [isFullScreenMode, isVertical, windowWidth, windowHeight, isIOS])
}
